/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useRef, useState} from "react"
import {useTranslation} from "react-i18next"
import {KlassDropdown, KlassDropdownProps} from "../Select"
import {Auth} from "types/auth"
import styles from "./UserSelectV3.module.css"
import {getFullName} from "helpers"
import {useAutocompleteUsers} from "hooks"
import {Icon} from "components/Icon"
import debounce from "lodash/debounce"
import {InputActionMeta} from "react-select"

type Props = Partial<KlassDropdownProps> & {
    type?: Auth.UserProfileType[]
    withProfiles?: boolean
    withProfilesCampuses?: boolean
    belongsToMyCampuses?: boolean
    getOptionLabel?: any
}

const UserSelectV3: React.FC<Props> = ({
    type,
    withProfiles = true,
    withProfilesCampuses = false,
    belongsToMyCampuses = true,
    getOptionLabel,
    ...props
}) => {
    const {t} = useTranslation(["common"])
    const [inputText, setInputText] = useState<string>("")
    const [searchText, setSearchText] = useState<string>("")

    const handleSearchDebounced = useRef(debounce((searchText) => setSearchText(searchText), 300)).current

    const handleInputChange = (inputText: string, meta: InputActionMeta) => {
        if (meta.action !== "input-blur" && meta.action !== "menu-close") {
            setInputText(inputText)
            // not trigger searching when clear text value
            if (!!inputText) handleSearchDebounced(inputText)
        }
    }

    const {isLoading, users} = useAutocompleteUsers({
        type,
        withProfiles,
        withProfilesCampuses,
        belongsToMyCampuses,
        search: searchText
    })

    const filterOption = useCallback(() => true, [])

    return (
        <KlassDropdown
            {...props}
            placeholder={props.placeholder || t("selectField.placeholder")}
            defaultOptions
            valueKey="id"
            labelKey="name"
            filterOption={filterOption}
            getOptionLabel={getOptionLabel || UserOptionLabel}
            inputValue={inputText}
            onInputChange={handleInputChange}
            options={users}
            isLoading={isLoading}
        />
    )
}

export default UserSelectV3

const UserOptionLabel = (option) => {
    const profile = option.profiles?.[0]
    const hasExtras = profile?.campusName || profile?.programName || profile?.startDate
    return (
        <div>
            <div>
                <span className={styles.userId}>{option.customUserId}</span>
                {getFullName(option) || option.name}
            </div>
            {hasExtras && (
                <div className={styles.extrasRow}>
                    {profile.campusName && (
                        <span className={styles.campus}>
                            <Icon icon="HOME" color="#1677ff" size={10} className={styles.icon} />
                            {profile.campusName}
                        </span>
                    )}
                    {profile.programName && (
                        <span className={styles.program}>
                            <Icon icon="PROGRAM" color="#52c41a" size={10} className={styles.icon} />
                            {profile.programName}
                        </span>
                    )}
                    {profile.startDate && (
                        <span className={styles.startDate}>
                            <Icon icon="ADMISSION_START_DATE" color="#fa8c16" size={10} className={styles.icon} />
                            {String(profile.startDate).slice(0, 10)}
                        </span>
                    )}
                </div>
            )}
        </div>
    )
}
